import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ListButton } from '@app/core/components/list/list.component';
import { TtScreenBlockService } from '@app/core/components/tt-screen-block/tt-screen-block.service';
import { RememberService } from '@app/core/services/remember.service';
import { UserDirectoryFilters, UserService, UsersGet, UsersListItem } from '@app/core/services/user.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({ selector: 'tt-users', templateUrl: './users.component.html', styleUrls: ['./users.component.css'], standalone: false })
export class UsersComponent implements OnInit {
    public page?: UsersGet;
    public items: UsersListItem[] = [];
    public filters: UserDirectoryFilters;
    public loading = false;
    public error = '';
    private pendingLoads = 0;
    public readonly rowButtons: ListButton<UsersListItem>[] = [{ id: 'newtab', icon: 'fas fa-external-link', type: 'secondary',
        onClick: ({ item }) => { if (item.item_state) this.navigator?.newTab({ to: item.item_state, parms: item.item_parms }); } }];

    constructor(private user: UserService, private remember: RememberService, private screen: TtScreenBlockService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
        this.filters = user.directoryFilters;
    }
    public async ngOnInit(): Promise<void> {
        try { this.page = await this.user.getDirectorySettings(); await this.load(); }
        catch (error) { this.showError(error); }
    }
    public async load(): Promise<void> {
        if (!this.page || this.page.filtervalue === undefined || this.page.filtervalue === null) return;
        this.screen.start(); this.loading = true; ++this.pendingLoads; this.items = []; this.error = '';
        try { this.items = await this.user.getList(this.filters.state, this.filters.category === 'i' ? this.filters.type : this.filters.role, this.page.filtervalue); }
        catch (error) { this.showError(error); }
        finally { this.loading = --this.pendingLoads > 0; if (!this.loading) this.screen.stop(); }
    }
    public changeState(value: string): void { if (value === 'ACT' || value === 'NOT_ACT' || value === 'ALL') this.changeFilter('state', value); }
    public changeCategory(value: string): void { if (value === 'i' || value === 'e') this.changeFilter('category', value); }
    public changeType(value: string): void { if (value === 'L' || value === 'T') this.changeFilter('type', value); }
    public changeRole(value: string): void { if (value === 'S' || value === 'C') this.changeFilter('role', value); }
    private changeFilter<K extends keyof UserDirectoryFilters>(field: K, value: UserDirectoryFilters[K]): void {
        if (this.filters[field] === value) return;
        this.filters[field] = value; void this.load();
    }
    public changeSearch(value: string): void {
        if (!this.page || value === undefined || value === this.page.filtervalue) return;
        this.page.filtervalue = value; if (value === '') this.clearSearch();
    }
    public clearSearch(): void { if (this.page) { this.page.filtervalue = ''; this.rememberSearch(); void this.load(); } }
    public search(): void { if (!this.loading) { this.rememberSearch(); void this.load(); } }
    private rememberSearch(): void {
        if (!this.page || typeof this.page.filtervalue !== 'string') return;
        void this.remember.remember('w_users.filtervalue', this.page.filtervalue).catch(error => this.showError(error));
    }
    public open(event: { item: UsersListItem; event: MouseEvent }): void {
        const item = event.item;
        if (item.item_path === '' || !item.item_state) return;
        const target = { to: item.item_state, parms: item.item_parms };
        if (event.event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
